export const worklistCopyDe = {
    worklist: "Aufgabenliste",
    yourTasks: "Ihre Aufgaben",
    description: "Erledigen Sie klinische Formulare, Einwilligungen und fehlende Ereignisdetails für Ihre Patienten.",
    emptyTitle: "Alles erledigt",
    emptyDescription: "Derzeit gibt es keine ausstehenden klinischen Aufgaben.",
    noMatchingTasks: "Keine passenden Aufgaben",
    noMatchingTasksDescription: "Ändern Sie Ihre Suche, den Tab oder die Filter.",
    complete: "Ausfüllen",
    completeDetails: "Details ausfüllen",
    completeDetailsPanelDescription: "Ergänzen Sie die fehlenden Angaben und kehren Sie dann zur Aufgabenliste zurück.",
    signConsent: "Einwilligung unterschreiben",
    closePanel: "Bereich schließen",
    noTaskSelected: "Aufgabe auswählen",
    noTaskSelectedDescription:
        "Wählen Sie eine Zeile, um ein Formular, eine Einwilligung oder fehlende Ereignisdaten hier zu ergänzen.",
    openDiary: "Tagebuch öffnen",
    openPatient: "Patient öffnen",
    toDo: "Zu erledigen",
    refresh: "Aktualisieren",
    forms: "Formulare",
    details: "Details",
    archived: "Archiviert",
    archive: "Archivieren",
    archiveAll: "Alle archivieren",
    restoreAll: "Alle wiederherstellen",
    tasksSelected: (count: number) => (count === 1 ? "1 Aufgabe ausgewählt" : `${count} Aufgaben ausgewählt`),
    selectedTasksDescription: "Wählen Sie eine Aktion für die ausgewählten Aufgaben.",
    selectTask: "Aufgabe auswählen",
    selectAllTasks: "Alle Aufgaben auswählen",
    restore: "Wiederherstellen",
    archiveSucceeded: (count: number) => (count === 1 ? "Aufgabe archiviert." : `${count} Aufgaben archiviert.`),
    archiveFailed: "Aufgabe konnte nicht archiviert werden. Bitte erneut versuchen.",
    restoreSucceeded: (count: number) =>
        count === 1 ? "Aufgabe wiederhergestellt." : `${count} Aufgaben wiederhergestellt.`,
    restoreFailed: "Aufgabe konnte nicht wiederhergestellt werden. Bitte erneut versuchen.",
    emptyArchivedTitle: "Nichts archiviert",
    emptyArchivedDescription: "Archivierte Aufgaben bleiben hier, bis Sie sie wiederherstellen.",
    allPeople: "Alle Personen",
    peopleFilterLabel: "Personen",
    selectPeople: "Klinikpersonal auswählen",
    organisationFilterLabel: "Organisation",
    allOrganisations: "Alle Organisationen",
    taskTypeFilterLabel: "Aufgabentyp",
    allTaskTypes: "Alle Aufgabentypen",
    searchTasks: "Aufgaben suchen",
    clearSearch: "Aufgabensuche löschen",
    filterTasks: "Aufgaben filtern",
    filterTasksDescription: "Wählen Sie Personen, die Organisation und den Aufgabentyp.",
    taskCompleteTitle: "Aufgabe gespeichert",
    taskCompleteDescription: "Fahren Sie mit der nächsten Person fort, wenn Sie soweit sind.",
    taskCompleteAllDoneTitle: "Alles erledigt",
    taskCompleteAllDoneDescription: "In dieser Liste gibt es keine weiteren Aufgaben.",
    continueToNextTask: "Weiter zur nächsten Aufgabe",
    doNext: "Als Nächstes",
    doNextDescription: (task: string, patientName: string, hospitalNumber: string | null) =>
        hospitalNumber
            ? `${task} für ${patientName}. Krankenhausnummer: ${hospitalNumber}`
            : `${task} für ${patientName}`,
    nextPatientTask: (name: string) => `Weiter: ${name}`,
    returnToWorklist: "Zur Aufgabenliste",
    patient: "Patient",
    hospitalNumber: "Krankenhausnummer",
    task: "Aufgabe",
    injectionDetailsTask: "Injektionsdetails",
    surgeryDetailsTask: "Operationsdetails",
    shockwaveDetailsTask: "Stoßwellendetails",
    procedureDetailsTask: "Verfahrensdetails",
    consentTask: "Einwilligung",
    due: "Fällig",
    status: "Status",
    actions: "Aktionen",
    dueLabel: "Fällig",
    blockedLabel: "Gesperrt",
    incompleteLabel: "Unvollständig",
    blockedBy: (blocker: string) => `Zuerst ${blocker} ausfüllen`,
    truncatedNotice: (total: number, shown: number) =>
        `Es werden die ersten ${shown} von ${total} Tagebüchern mit klinischen Formularen angezeigt. Schränken Sie Ihre Patientenliste ein, wenn Sie den Rest benötigen.`,
    unknownPatient: "Unbekannter Patient",
    notDefined: "Nicht definiert",
    loading: "Aufgabenliste wird geladen…",
    errorLoading: (message: string) => `Aufgabenliste konnte nicht geladen werden: ${message}`,
    taskCount: (count: number) => (count === 1 ? "1 Aufgabe" : `${count} Aufgaben`),
};
